import React from 'react';
import { motion } from 'framer-motion';
import { CalendarCheckIcon, ShieldCheckIcon, SparklesIcon, ClockIcon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    title: 'Más reservas',
    description: 'Tus clientes podrán reservar o contactarte fácilmente desde el móvil.',
    icon: <CalendarCheckIcon className="w-8 h-8 text-primary" data-id="element-1" />
  }, {
    title: 'Más confianza',
    description: 'Una web profesional transmite autoridad.',
    icon: <ShieldCheckIcon className="w-8 h-8 text-primary" data-id="element-2" />
  }, {
    title: 'Imagen profesional',
    description: 'Tu negocio tendrá presencia online moderna.',
    icon: <SparklesIcon className="w-8 h-8 text-primary" data-id="element-3" />
  }, {
    title: 'Disponible 24 horas',
    description: 'Tu web trabajará incluso cuando tu negocio esté cerrado.',
    icon: <ClockIcon className="w-8 h-8 text-primary" data-id="element-4" />
  }];
  return <section id="beneficios" className="py-20 bg-light" data-id="element-5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-6">
        <div className="text-center mb-16" data-id="element-7">
          <motion.h2 className="text-3xl md:text-4xl font-bold text-text" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-8">
            Lo que esta web puede hacer por tu negocio
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-9">
          {benefits.map((benefit, index) => <motion.div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-10">
              <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mb-6" data-id="element-11">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-semibold text-text mb-3" data-id="element-12">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-13">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}